module.exports = __webpack_public_path__ + "static/img/chu1.f221acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chu1.jpg
// module id = 04DG
// module chunks = 1